import { Icon } from "./Icons";

type PillKind = "default" | "red" | "green" | "accent" | "glass";

const PALETTE: Record<
  PillKind,
  { bg: string; fg: string; bd: string }
> = {
  default: {
    bg: "oklch(0.22 0.008 280 / 0.85)",
    fg: "var(--text)",
    bd: "oklch(0.32 0.01 280 / 0.5)",
  },
  red: {
    bg: "oklch(0.32 0.1 25 / 0.9)",
    fg: "var(--red)",
    bd: "oklch(0.42 0.12 25 / 0.5)",
  },
  green: {
    bg: "oklch(0.28 0.05 155 / 0.9)",
    fg: "var(--green)",
    bd: "oklch(0.4 0.08 155 / 0.5)",
  },
  accent: {
    bg: "oklch(0.28 0.04 270 / 0.9)",
    fg: "var(--accent)",
    bd: "oklch(0.45 0.1 270 / 0.5)",
  },
  glass: {
    bg: "oklch(0.18 0.005 280 / 0.55)",
    fg: "var(--text)",
    bd: "oklch(1 0 0 / 0.08)",
  },
};

export function Pill({
  children,
  kind = "default",
  icon,
  size = "md",
  mono = false,
  style,
}: {
  children: React.ReactNode;
  kind?: PillKind;
  icon?: string;
  size?: "sm" | "md";
  mono?: boolean;
  style?: React.CSSProperties;
}) {
  const pad = size === "sm" ? "4px 9px" : "6px 12px";
  const fz = size === "sm" ? 11 : 12.5;
  const p = PALETTE[kind];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: pad,
        borderRadius: 999,
        fontSize: fz,
        fontFamily: mono ? "var(--font-mono)" : "var(--font-sans)",
        background: p.bg,
        color: p.fg,
        border: `1px solid ${p.bd}`,
        backdropFilter: "blur(20px) saturate(140%)",
        WebkitBackdropFilter: "blur(20px) saturate(140%)",
        letterSpacing: mono ? "0.04em" : "-0.005em",
        fontWeight: 500,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {icon && <Icon name={icon} size={fz + 2} stroke={1.8} />}
      {children}
    </span>
  );
}

export function RecDot({ animated = true }: { animated?: boolean }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "var(--red)",
        animation: animated ? "recPulse 1.6s infinite" : undefined,
      }}
    />
  );
}
